import React, { useState, useEffect } from 'react'
import BlankAnswer from "./BlankSingle/TestAnswerBlank"
const ParentBlankAnswer = () => {
    // States
    const [answerArray, setAnswerArray] = useState([{ title: "", id: 1, correct: false }])

    const AddAnswer = () => {
        let PreviousItem = answerArray[answerArray.length - 1]
        setAnswerArray(answerArray => [...answerArray, { title: "", id: PreviousItem ? PreviousItem.id + 1 : 1, correct: false }])
    }
    const DeleteAnswer = (title, id) => {
        let ArrayAfterDelete = answerArray.filter(Answer => Answer.id !== id)
        setAnswerArray(ArrayAfterDelete)
    }
    return (
        <>
            <div className="container">
                {
                    answerArray &&
                    answerArray.map((item, index) => {
                        return (
                            <BlankAnswer
                                title={item.title}
                                index={index}
                                correct={item.correct}
                                answerArray={answerArray}
                                setAnswerArray={setAnswerArray}
                                DeleteAnswer={DeleteAnswer}
                                id={item.id}
                            />
                        )
                    })
                }
                {
                    answerArray.length < 4 &&
                    <div className="col-12">
                        <div className="d-flex justify-content-center align-items-center">
                            <div
                                className="border px-5 mt-2"
                                onClick={AddAnswer}
                            >
                                <span>+</span>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}

export default ParentBlankAnswer
